export default function BrokerStatus({ isConnected }) {
  return (
    <div className="mb-4">
      <p className="text-red-400 font-semibold">
        Connection: <span className={isConnected ? 'text-purple-500' : 'text-red-500'}>{isConnected ? 'Connected' : 'Not Connected'}</span>
      </p>
      <p className="text-sm text-gray-300 mt-1">
        {isConnected ? 'You are connected to your brokerage account.' : 'Please note that you must complete integration with your brokerage account before starting a new automation.'}
      </p>


    </div>
  );
}

  